import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  UserPlusIcon,
  BuildingStorefrontIcon,
  AcademicCapIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  DocumentTextIcon,
  ShieldCheckIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import styles from './Sidebar.module.css';

const NAV_ITEMS = [
  { path: '/dashboard', label: 'Dashboard', icon: HomeIcon },
  { path: '/personas', label: 'Emprendedores', icon: UsersIcon },
  { path: '/personas-interes', label: 'Personas', icon: UserPlusIcon },
  { path: '/negocios', label: 'Negocios', icon: BuildingStorefrontIcon },
  { path: '/capacitaciones', label: 'Capacitaciones', icon: AcademicCapIcon },
  { path: '/eventos', label: 'Eventos', icon: CalendarDaysIcon },
  { path: '/apoyos', label: 'Fortalecimiento', icon: ChartBarIcon },
  { path: '/reportes', label: 'Reportes', icon: DocumentTextIcon },
  { path: '/auditoria', label: 'Auditoría', icon: ShieldCheckIcon, roles: ['admin'] },
  { path: '/usuarios', label: 'Usuarios', icon: UsersIcon, roles: ['admin'] },
  { path: '/configuracion', label: 'Configuración', icon: Cog6ToothIcon },
];

const Sidebar = ({ user, collapsed, onLogout }) => {
  const filteredItems = NAV_ITEMS.filter(
    (item) => !item.roles || item.roles.includes(user?.rol)
  );

  return (
    <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      <div className={styles.logo}>
        <img src="/logo_blanco.png" alt="SITRE" className={styles.logoImage} />
        {!collapsed && (
          <div className={styles.logoText}>
            <strong>SITRE</strong>
            <span>Alcaldía de Soledad</span>
          </div>
        )}
      </div>
      <nav className={styles.nav}>
        {filteredItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.active : ''}`
            }
            title={collapsed ? item.label : ''}
          >
            <item.icon width={22} height={22} />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
